import { useContext } from 'react';

import AuthContext from '@/hooks/AuthContext';

export default function useAuth() {
  const { isSignedIn, isLoading, refresh, roles, isInternal } = useContext(AuthContext);

  return {
    isSignedIn: isSignedIn,
    isLoading: isLoading,
    refresh: refresh,
    roles,
    isInternal,
  };
}
